var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiLogoutLtr = function SvgUiLogoutLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M86.636 10c5.262 0 9.567 4.363 9.653 9.74l.001.164v60.192c0 5.398-4.253 9.815-9.495 9.903l-.16.001H64.619c-1.285 0-2.326-1.069-2.326-2.387 0-1.294 1.004-2.348 2.257-2.385l.069-.001h22.018c2.716 0 4.953-2.266 5-5.041V19.904c0-2.786-2.207-5.081-4.913-5.13H64.618c-1.285 0-2.326-1.07-2.326-2.387 0-1.295 1.004-2.349 2.257-2.386l.069-.001z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.711 72.1 4.646 51.553a2.2 2.2 0 0 1-.485-.763 2.46 2.46 0 0 1 0-1.752c.107-.286.273-.545.485-.763l20.065-20.708a2.423 2.423 0 0 1 3.436-.04c.96.941.978 2.485.04 3.449L12.132 47.4h61.44a2.43 2.43 0 0 1 2.425 2.434 2.43 2.43 0 0 1-2.425 2.434h-61.44l16.055 16.423c.938.963.92 2.508-.04 3.449a2.423 2.423 0 0 1-3.436-.04",
    clipRule: "evenodd"
  })));
};
export default SvgUiLogoutLtr;